import Service1cCard from 'entities/Service1cCard';
import CustomOverlayLink from 'shared/CustomOverlayLink';
import ITSModal from 'shared/Service1cModals/ITSModal';
import ButtonGoTo from 'shared/ButtonGoTo';

import { PRICE_1C_LINK } from 'constants/global';

const CONFIGURE_SETUP = 'Подбор и настройка конфигурации';
const PROCESS_TRANSPARENCY = 'Повышение прозрачности процессов';
const PREPARE_ARCHITECTURE = 'Подготовка архитектуры решения';
const IMPLEMENT_SYSTEM = 'Настройка и внедрение системы';
const AUTOMATE_KEY_OPERATIONS = 'Автоматизация ключевых операций';
const TRAIN_AND_LAUNCH = 'Обучение сотрудников и запуск';
const INITIAL_AUDIT_STEPS = [
  'Интервью с ключевыми участниками',
  'Анализ текущих процессов и системы',
  'Формирование рекомендаций',
  'Презентация и согласование плана',
];

const illustrationsSize = {
  w: { mobile: '650px', laptop: '1000px' },
  h: { mobile: '360px', laptop: '555px' },
};
const illustrationsPositioning = [
  {
    top: { mobile: '100px', laptop: '130px' },
    right: { mobile: '-280px', laptop: '-380px' },
    transform: 'rotate(110deg)',
  },
  {
    top: { mobile: '-55px', laptop: '-210px' },
    right: { mobile: '-300px', laptop: '-455px' },
    transform: 'rotate(213deg)',
  },
  {
    top: { mobile: '-155px', laptop: '-320px' },
    right: { mobile: '-420px', laptop: '-660px' },
    transform: 'rotate(-50deg)',
  },
  {
    top: { mobile: '-95px', laptop: '-140px' },
    right: { mobile: '-280px', laptop: '-445px' },
    transform: 'rotate(70deg)',
  },
];

const LABELS_NAMES = {
  strategy: 'Стратегия и аудит',
  implementSystem: 'Внедрение систем',
  processAutomatization: 'Автоматизация процессов',
  optimization: 'Оптимизация',
  oneCSupport: 'Сопровождение 1С\u2011решений',
};

const labels = [
  LABELS_NAMES.strategy,
  LABELS_NAMES.implementSystem,
  LABELS_NAMES.processAutomatization,
  LABELS_NAMES.optimization,
  LABELS_NAMES.oneCSupport,
];

const tabsData = {
  [LABELS_NAMES.strategy]: [
    {
      title: 'Предпроектное обследование 1С\u2011ландшафта',
      subTitle: 'Анализ текущего ИТ\u2011ландшафта для моделирования целевой архитектуры',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[0] },
      modalData: {
        subtitle:
          'Анализируем бизнес-процессы и 1С\u2011ландшафт компании для поиска оптимального сценария внедрения или развития. На основе экспертизы архитекторов и аналитиков создаём пошаговый план действий.',
        cardsData: [
          [
            'Когда планируете внедрение или масштабирование 1С',
            'Когда система уже есть, но работает некорректно',
            'Когда нет чёткого понимания, с чего начать изменения',
          ],
          [
            'Чёткое понимание текущего состояния системы',
            'Приоритизированный план развития на 3–6–12 месяцев',
            'Оценку бюджета и ресурсов',
            'Снижение рисков при внедрении',
          ],
          INITIAL_AUDIT_STEPS,
        ],
      },
    },
    {
      title: 'Эффективная финансовая функция на 1С',
      subTitle: 'Настраиваем финансовый контур: учёт, бюджетирование и отчётность',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[1] },
      modalData: {
        subtitle:
          'Настраиваем и адаптируем финансовый контур 1С под процессы компании. <br /> Помогаем выстроить прозрачное управление финансами, повысить контроль расходов и упростить анализ ключевых показателей.',
        cardsData: [
          [
            'Когда нет прозрачности по расходам и платежам',
            'Когда финансовый контроль ведётся вручную',
            'Когда сложно консолидировать данные',
            'Когда не хватает инструментов для анализа',
          ],
          [
            'Прозрачную систему финансового управления',
            'Повышение финансовой дисциплины',
            'Снижение издержек и потерь',
            'Централизованный контроль процессов',
          ],
          [
            'Анализ финансовых процессов компании',
            CONFIGURE_SETUP,
            'Адаптация системы под задачи бизнеса',
            'Запуск и сопровождение решения',
          ],
        ],
      },
    },
  ],
  [LABELS_NAMES.implementSystem]: [
    {
      title: 'Внедрение 1С:ERP',
      subTitle: 'Внедряем систему управления ресурсами предприятия на базе 1С',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[1] },
      modalData: {
        subtitle:
          'Внедряем 1С:ERP для комплексной автоматизации бизнес-процессов компании. <br /> Интегрируем финансы, закупки, производство, продажи и склад в единую управляемую систему.',
        cardsData: [
          [
            'Когда процессы работают разрозненно',
            'Когда нет единой системы управления',
            'Когда сложно контролировать операции',
            'Когда не хватает данных для решений',
          ],
          [
            'Единое пространство управления бизнесом',
            'Автоматизацию ключевых процессов',
            'Снижение операционных издержек',
            PROCESS_TRANSPARENCY,
          ],
          [
            'Анализ процессов и требований бизнеса',
            PREPARE_ARCHITECTURE,
            IMPLEMENT_SYSTEM,
            'Обучение и запуск пользователей',
          ],
        ],
      },
    },
    {
      title: 'Внедрение 1С:УХ',
      subTitle: 'Внедряем систему управления холдингом и консолидированной отчётности',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[2] },
      modalData: {
        subtitle:
          'Внедряем 1С: Управление холдингом для сквозного контроля группы компаний. Помогаем выстроить единый контур учёта, планирования и эффективного управления финансами.',
        cardsData: [
          [
            'Когда нет единой системы управления холдингом',
            'Когда сложно собирать консолидированную отчётность',
            'Когда финансовые процессы разрозненны',
            'Когда не хватает прозрачности в управлении',
          ],
          [
            'Централизованное управление группой',
            'Унифицированную учётную политику',
            'Прозрачную финансовую отчётность',
            'Повышение качества управления',
          ],
          [
            'Анализ структуры и процессов холдинга',
            PREPARE_ARCHITECTURE,
            IMPLEMENT_SYSTEM,
            'Запуск и сопровождение пользователей',
          ],
        ],
      },
    },
    {
      title: 'Внедрение 1С:УТ',
      subTitle: 'Внедряем систему управления торговлей и операциями продаж',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[0] },
      modalData: {
        subtitle:
          'Внедряем 1С:Управление торговлей для автоматизации продаж, закупок и склада. Помогаем повысить прозрачность процессов, избавиться от рутины и усилить контроль над коммерческой деятельностью.',
        cardsData: [
          [
            'Когда заказы и документы обрабатываются вручную',
            'Когда нет прозрачности по товарным остаткам',
            'Когда сложно анализировать прибыльность товаров',
            'Когда ошибки приводят к финансовым потерям',
          ],
          [
            'Автоматизацию торговых процессов',
            'Ускорение обработки заказов',
            'Контроль товарных запасов',
            'Повышение прозрачности операций',
          ],
          [
            'Анализ текущих торговых процессов',
            CONFIGURE_SETUP,
            'Интеграция и запуск системы',
            'Обучение и поддержка пользователей',
          ],
        ],
      },
    },
    {
      title: 'Внедрение 1С:ДО',
      subTitle: 'Внедряем систему электронного документооборота на базе 1С',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[3] },
      modalData: {
        subtitle:
          'Внедряем 1С:Документооборот для управления документами и задачами компании. <br /> Помогаем выстроить прозрачные процессы согласования, ускорить работу сотрудников и снизить потери документов.',
        cardsData: [
          [
            'Когда сложно согласовывать и контролировать документы',
            'Когда команда работает удалённо и теряется с ними связь',
            'Когда в общем потоке теряются задачи и документы',
            'Когда рутинные процессы занимают слишком много времени',
          ],
          [
            'Единое пространство для работы с документами',
            'Контроль исполнения задач и документов',
            'Ускорение согласований и подписания',
            PROCESS_TRANSPARENCY,
          ],
          [
            'Анализ текущего документооборота',
            'Настройка маршрутов согласования',
            'Внедрение и интеграция системы',
            TRAIN_AND_LAUNCH,
          ],
        ],
      },
    },
  ],
  [LABELS_NAMES.processAutomatization]: [
    {
      title: 'Управление складами на базе 1С',
      subTitle: 'Автоматизируем складские процессы: приёмку, хранение и отгрузку',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[3] },
      modalData: {
        subtitle:
          'Внедряем систему управления складами на базе 1С под процессы компании. Помогаем ускорить обработку заказов, минимизировать ошибки учёта и повысить прозрачность складских операций.',
        cardsData: [
          [
            'Когда на складе много ручных операций',
            'Когда в складском учёте часто возникают ошибки',
            'Когда нет точных данных по остаткам товаров',
            'Когда сборка и обработка заказов идут медленно',
          ],
          [
            'Точный учёт движения товаров',
            'Ускорение складских операций',
            'Снижение потерь и ошибок',
            'Прозрачность складских процессов',
          ],
          [
            'Анализ складских процессов компании',
            'Подбор и настройка решения',
            AUTOMATE_KEY_OPERATIONS,
            'Запуск и сопровождение системы',
          ],
        ],
      },
    },
    {
      title: 'Управление производством на базе 1С',
      subTitle: 'Автоматизируем планирование и учёт производственных процессов',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[0] },
      modalData: {
        subtitle:
          'Внедряем решения 1С для автоматизации производственных процессов компании. <br /> Помогаем выстроить планирование, контроль операций и управление затратами на всех этапах производства.',
        cardsData: [
          [
            'Когда сложно планировать загрузку производства',
            'Когда нет контроля производственных затрат',
            'Когда процессы зависят от ручного управления',
            'Когда трудно контролировать выполнение заказов',
          ],
          [
            'Планирование производственных мощностей',
            'Контроль операций и материальных потоков',
            PROCESS_TRANSPARENCY,
            'Снижение затрат и простоев',
          ],
          [
            'Анализ производственных процессов',
            CONFIGURE_SETUP,
            AUTOMATE_KEY_OPERATIONS,
            TRAIN_AND_LAUNCH,
          ],
        ],
      },
    },
  ],
  [LABELS_NAMES.optimization]: [
    {
      title: 'Оптимизация скорости работы 1С',
      subTitle: 'Анализируем производительность системы и устраняем узкие места',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[2] },
      modalData: {
        subtitle:
          'Анализируем производительность 1С и устраняем причины медленной работы системы. <br /> Оптимизируем код, настройки и инфраструктуру для стабильной и быстрой работы пользователей.',
        cardsData: [
          [
            'Когда система работает медленно и нестабильно',
            'Когда пользователи долго ждут выполнения операций',
            'Когда снижается продуктивность сотрудников',
            'Когда возрастают операционные затраты',
          ],
          [
            'Ускорение работы системы',
            'Снижение времени ожидания операций',
            'Повышение стабильности 1С',
            'Рост продуктивности сотрудников',
          ],
          [
            'Анализ производительности системы',
            'Поиск узких мест и ошибок',
            'Оптимизация кода и настроек',
            'Тестирование и контроль изменений',
          ],
        ],
      },
    },
    {
      title: 'Внедрение автотестирования',
      subTitle: 'Настраиваем автоматическое тестирование доработок и обновлений 1С',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[3] },
      modalData: {
        subtitle:
          'Внедряем инструменты автотестирования для проверки стабильности решений на базе 1С. <br /> Помогаем быстрее выпускать изменения, снижать количество ошибок и повышать качество системы.',
        cardsData: [
          [
            'Когда после обновлений возникают ошибки',
            'Когда ручная проверка обновлений занимает много времени',
            'Когда подготовка и запуск релизов требуют много ресурсов',
            'Когда высоки риски нестабильной работы после релиза',
          ],
          [
            'Повышение качества решений',
            'Снижение количества ошибок',
            'Ускорение выпуска изменений',
            'Стабильную работу системы',
          ],
          INITIAL_AUDIT_STEPS,
        ],
      },
    },
  ],
  [LABELS_NAMES.oneCSupport]: [
    {
      title: 'Сопровождение 1С\u2011решений',
      subTitle: 'Обеспечиваем информационную и техническую поддержку цифровых продуктов',
      illustrationProps: { ...illustrationsSize, ...illustrationsPositioning[0] },
      ModalComponent: ITSModal,
    },
  ],
};

const btnText = 'Скачать прейскурант решений 1С';

export const oneCMultiTabsCardsData = {
  title: 'Комплексный подход к работе с 1С',
  titleProps: { maxW: { mobile: '400px', tablet: 'unset', laptop: '700px' } },
  gridProps: { gap: { mobile: '16px', tablet: '20px' } },
  CardComponent: Service1cCard,
  labels,
  tabsData,
  RenderBottom: (
    <>
      <ButtonGoTo
        as="div"
        size="secondary"
        w="full"
        btnText={btnText}
        enableGoTo={false}
        _focusWithin={{ bgColor: 'bg.black', color: 'text.white' }}
      >
        <CustomOverlayLink title={btnText} link={PRICE_1C_LINK} isExternal />
      </ButtonGoTo>
    </>
  ),
};
